import { lazy, Suspense } from 'react';

const TripsPerHourChart = lazy(() =>
  import('./Chart.js').then((m) => ({ default: m.TripsPerHourChart })),
);

export function LazyTripsPerHourChart({ data }: { data: Array<{ hour: number; count: number }> }) {
  return (
    <Suspense
      fallback={
        <div className="card p-4">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Trips per hour, today</p>
          <div className="mt-2 h-56 animate-pulse rounded-md bg-slate-100" />
        </div>
      }
    >
      <TripsPerHourChart data={data} />
    </Suspense>
  );
}
